module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3894461559/src/~/core-js/library/modules/_redefine.js
// module id = L1xW
// module chunks = 6